const $ = jQuery.noConflict();
export const tableWrapper = (() => {
    $('.wp-block-table').wrap('<div class="table-wrapper"></div>');
});
